import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== POMOCNICZE FUNKCJE ====

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomA1() {
  // a1 z przedziału -9..-2 ∪ 2..9 (bez -1, 0, 1)
  const candidates = [];
  for (let x = -9; x <= 9; x++) {
    if (Math.abs(x) >= 2 && Math.abs(x) <= 9) {
      candidates.push(x);
    }
  }
  const idx = Math.floor(Math.random() * candidates.length);
  return candidates[idx];
}

// ==== GENERATOR ====

export function generateTask() {
  const a1 = randomA1();

  // q całkowite 2..7, losowo dodatnie lub ujemne
  const baseQ = randomInt(2, 7);
  const sign = Math.random() < 0.5 ? 1 : -1;
  const q = sign * baseQ;

  // liczba wyrazów jak w zadaniach z sumą: 3..6
  const n = randomInt(3, 6);

  // S_n = a1 * (1 - q^n) / (1 - q), q ≠ 1
  const sum =
    q === 1
      ? a1 * n
      : (a1 * (1 - Math.pow(q, n))) / (1 - q);

  return {
    type: "FindA1FromSumGeoTask",
    data: { sum, q, n, a1 }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { sum, q, n } = data;

  return (
    <>
      <p>
        Suma pierwszych <InlineMath math={`${n}`} /> wyrazów ciągu
        geometrycznego wynosi <InlineMath math={`${sum}`} />.
      </p>
      <p>
        Iloraz ciągu wynosi <InlineMath math={`q = ${q}`} />.
      </p>
      <p>
        Oblicz pierwszy wyraz <InlineMath math="a_1" /> tego ciągu.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <div className="flex items-center gap-2">
      <InlineMath math={"a_1 ="} />
      <FractionInput
        value={userAnswer}
        onChange={onChange}
        disabled={disabled}
        label={"a_1"}
      />
    </div>
  );
}

// ==== SPRAWDZANIE ====

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = userAnswer.parsed;
  if (given === null) return false;

  return Math.abs(given - data.a1) < 0.01;
}

// ==== POPRAWNA ODPOWIEDŹ ====

export function renderAnswer({ data }) {
  return <InlineMath math={`a_1 = ${data.a1}`} />;
}

// ==== WYJAŚNIENIE KROK PO KROKU ====

export function renderExplanation({ data }) {
  const { sum, q, n, a1 } = data;

  const qn = Math.pow(q, n);
  const numerator = 1 - qn;
  const denominator = 1 - q;

  const computedA1 = (sum * denominator) / numerator;

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Wzór na sumę{" "}
        <InlineMath math={"S_n"} /> ciągu geometrycznego dla{" "}
        <InlineMath math={"q \\neq 1"} />:
      </p>
      <BlockMath math={"S_n = a_1 \\cdot \\frac{1 - q^n}{1 - q}"} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane do wzoru.
      </p>
      <BlockMath
        math={`${sum} = a_1 \\cdot \\frac{1 - (${q})^{${n}}}{1 - (${q})}`}
      />
      <BlockMath
        math={`${sum} = a_1 \\cdot \\frac{${numerator}}{${denominator}}`}
      />

      <p>
        <strong>Krok 3:</strong> Wyznaczamy{" "}
        <InlineMath math={"a_1"} /> z równania.
      </p>
      <BlockMath
        math={`a_1 = ${sum} \\cdot \\frac{${denominator}}{${numerator}} = ${computedA1}`}
      />
      <p>
        Otrzymujemy <InlineMath math={`a_1 = ${a1}`} />.
      </p>
    </div>
  );
}


// ==== ODP. UŻYTKOWNIKA W PODGLĄDZIE ====

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`a_1 = ${userAnswer.raw}`} />;
}
